import { eq } from "drizzle-orm";
import { a as authServer } from "../../chunks/auth-server.js";
import { d as db, u as userCard } from "../../chunks/index3.js";
import { c as cookieStrToObj } from "../../chunks/utils2.js";
import { f as fakeCards } from "../../chunks/fakeCards.js";
const BETTER_AUTH_SESSION_COOKIE = "better-auth.session_token";
const load = async ({ locals }) => {
  const user = locals.user;
  let wallet = [];
  if (user) {
    wallet = await db.select().from(userCard).where(eq(userCard.userId, user.id));
  }
  return { cards: fakeCards, wallet };
};
const actions = {
  async signout(event) {
    const authResponse = await authServer.api.signOut({
      headers: event.request.headers,
      asResponse: true
    });
    const setCookieHeader = authResponse.headers.get("set-cookie") ?? "";
    const cookiesObj = cookieStrToObj(setCookieHeader);
    event.cookies.delete(BETTER_AUTH_SESSION_COOKIE, { path: "/", ...cookiesObj });
    const data = await authResponse.json();
    return data;
  }
};
export {
  actions,
  load
};
